import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { AcademicsService } from 'src/app/service/academics.service';
import { CoursesService } from 'src/app/service/courses.service';
@Component({
  selector: 'app-semester-student-grouping-update',
  templateUrl: './semester-student-grouping-update.component.html',
  styleUrls: ['./semester-student-grouping-update.component.scss']
})
export class SemesterStudentGroupingUpdateComponent implements OnInit {
  showLoader: boolean = false;
  creating: boolean = false;
  semesterStudentGroupID: any;
  updating: boolean = false;
  courses: any = [];
  constructor(
    // private userService: UserService,
    //  private ispService: IspService,
    private toastrService: ToastrService
    // , private roleService: RoleService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , private academicsService: AcademicsService
    , public coursesService: CoursesService
  ) {

  }

  ngOnInit(): void {
    this.showLoader = true;
    this.getAciveCourses();
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        this.semesterStudentGroupID = params['semesterStudentGroupID'] || "";

        if (this.semesterStudentGroupID != "") {
          this.getSemesterStudentGroup();
          this.showLoader = false;
          
        } else {
          this.toastrService.warning(this.translate.instant('CAN_NOT_GET_DATA_BE'));
          this.router.navigate(['/enrolment/semester-student-group']);
        }
      });



  }
  updateSemesterStudentGroup = new FormGroup({
    code: new FormControl('', [
      Validators.required,
    ]),
    nameAr: new FormControl('', [
      Validators.required, 
      ]),
    nameEn: new FormControl('', [
      Validators.required,
      ]),
    orderNo: new FormControl('', [
      Validators.required,
    ]),
    type: new FormControl('', [
      Validators.required,
    ]),
    active: new FormControl(0, [
      Validators.required,
    ]),
    course: new FormControl('', [
      Validators.required,
    ]),
    
    
  }, );

  getSemesterStudentGroup() {
    this.academicsService.getSemesterStudentGroup(this.semesterStudentGroupID).subscribe(
      data => {
        console.log(data);
      //  this.CurrentCourseData = data;
       this.updateSemesterStudentGroup.controls.code.setValue(data.egroupCode);
       this.updateSemesterStudentGroup.controls.nameAr.setValue(data.egroupNameAr);
       this.updateSemesterStudentGroup.controls.nameEn.setValue(data.egroupNameEn);
       this.updateSemesterStudentGroup.controls.type.setValue(data.egroupType);
       // let dateString = formatDate(new Date(data.timeFrom),'yyyy-MM-dd',this.locale);
       this.updateSemesterStudentGroup.controls.orderNo.setValue(data.orderNo);
       this.updateSemesterStudentGroup.controls.active.setValue(data.active);
       this.updateSemesterStudentGroup.controls.course.setValue(data.active);    
       this.updateSemesterStudentGroup.controls.course.setValue(data.subjectid);  
     },
     error => {
       this.updating = false;
       this.toastrService.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
     }
   );

 }
 changeactive() {

 }

 updateSemesterStudentGroupSubmit() {
  if (this.updateSemesterStudentGroup.valid) {
    // call your service 
    let code = this.updateSemesterStudentGroup.controls.code.value;
    let nameAr = this.updateSemesterStudentGroup.controls.nameAr.value;
    let nameEn = this.updateSemesterStudentGroup.controls.nameEn.value;
    let type = this.updateSemesterStudentGroup.controls.type.value;
    let orderNo = this.updateSemesterStudentGroup.controls.orderNo.value;
    let active = this.updateSemesterStudentGroup.controls.active.value;
    let subjectid = this.updateSemesterStudentGroup.controls.course.value

    // console.log('ssss');
    // console.log(nameAr,nameEn,orderNo);
    this.modifySemesterStudentGroup(code, nameAr, nameEn, type,subjectid,orderNo ,active)
  }
  else {
    this.updateSemesterStudentGroup.markAllAsTouched();
    this.updateSemesterStudentGroup.markAsDirty();
  }
}

modifySemesterStudentGroup(egroupCode: string, egroupNameAr: string, egroupNameEn: string, egroupType: string,subjectid:any, orderNo: any, active: string) {
  this.updating = true;
  let username = this.globals.currentUserInfo.username;

  this.academicsService.updateSemesterStudentGroup(username, this.semesterStudentGroupID, 10, egroupCode, egroupNameAr, egroupNameEn, egroupType,subjectid, orderNo,active)
    .subscribe(
      data => {
        console.log(data);
        if (data.sts == "SUCCESS") {
          this.updating = false;
          this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
          this.router.navigate(['/enrolment/semester-student-group']);
        } else {
          this.updating = false;
          this.toastrService.error(this.translate.instant('CAN_NOT_UPDATE'));
        }
        this.updating = false;
      },
      error => {
        this.updating = false;
        this.toastrService.error(this.translate.instant('CAN_NOT_UPDATE'));
      }
    );
}

getAciveCourses() {
  this.academicsService.getActiveSubjectList(this.globals.orgId).subscribe(
    data => {
      this.courses = data;
      this.showLoader = false;
    },
    error => {
      this.toastrService.error(this.translate.instant("CAN_NOT_GET_DATA_BE"));
      this.showLoader = false;
    }
  );
}
}
